import useLocale from "hooks/useLocale";
import { DefaultMDXProvider } from "../components/default-mdx-provider";
import * as IndicatorsAr from "../content/ar/indicators.mdx";
import * as IndicatorsDe from "../content/de/indicators.mdx";
import * as IndicatorsEn from "../content/en/indicators.mdx";
import * as IndicatorsEs from "../content/es/indicators.mdx";
import * as IndicatorsFr from "../content/fr/indicators.mdx";
import * as IndicatorsRu from "../content/ru/indicators.mdx";
import * as IndicatorsZh from "../content/zh/indicators.mdx";

const localeContents = {
  ar: IndicatorsAr,
  de: IndicatorsDe,
  en: IndicatorsEn,
  es: IndicatorsEs,
  fr: IndicatorsFr,
  ru: IndicatorsRu,
  zh: IndicatorsZh,
} as const;

export default function Indicators() {
  const locale = useLocale();
  const { default: Content, frontmatter } = localeContents[locale];

  return (
    <DefaultMDXProvider frontmatter={frontmatter}>
      <Content />
    </DefaultMDXProvider>
  );
}
